/* eslint-disable no-plusplus */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from "react";
import { connect } from "react-redux";
import { NavItem } from "reactstrap";
import { NavLink } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import classnames from "classnames";
import IntlMessages from "../../helpers/IntlMessages";
import ApplicationMenu from "../common/ApplicationMenu";
import { getLolRequestsSearch, getLolRequestsWithOrder, getLolRequestsWithFilter } from "../../redux/request/actions";
// import { getReservationOptions } from '../../redux/alacarte/actions';

class AlacarteApplicationMenu extends Component {
  addFilter = (column, value) => {
    // eslint-disable-next-line no-shadow
    const { requestApp, getLolRequestsWithFilter, getLolRequestsWithOrder } = this.props;
    getLolRequestsWithFilter(column, value);
    if (requestApp.orderColumnAlacarte) {
      getLolRequestsWithOrder(`${requestApp.orderColumnAlacarte.column}`, `${requestApp.orderColumnAlacarte.direction}`);
    }
  };

  render() {
    const {
      requestApp: { lolRequestsItems, allLolRequestsItems, filterLolRequests, loading }
    } = this.props;
    // const { getReservationOptions } = this.props.alacarteApp;
    let openCount = 0;
    let closedCount = 0;
    let pendingCount = 0;
    let canceledCount = 0;

    Object.values(allLolRequestsItems).forEach(request => {
      if (request.status === "OPEN") {
        openCount++;
      } else if (request.status === "CLOSED") {
        closedCount++;
      } else if (request.status === "PENDING") {
        pendingCount++;
      } else if (request.status === "CANCELED") {
        canceledCount++;
      }
    });

    return (
      <ApplicationMenu>
        <PerfectScrollbar options={{ suppressScrollX: true, wheelPropagation: false }}>
          <div className="p-4">
            <p className="text-muted text-small">
              <IntlMessages id="request.status" />
            </p>
            <ul className="list-unstyled mb-5">
              <NavItem className={classnames({ active: !filterLolRequests })}>
                <NavLink to="#" onClick={e => this.addFilter("", "")}>
                  <i className="simple-icon-reload" />
                  <IntlMessages id="request.all-tasks" />
                  <span className="float-right">{loading && Object.keys(allLolRequestsItems).length}</span>
                </NavLink>
              </NavItem>
              <NavItem
                className={classnames({
                  active: filterLolRequests && filterLolRequests.column === "status" && filterLolRequests.value === "OPEN"
                })}
              >
                <NavLink to="#" onClick={e => this.addFilter("status", "OPEN")}>
                  <i className="simple-icon-exclamation" />
                  <IntlMessages id="request.open-tasks" />
                  <span className="float-right">{loading && openCount}</span>
                </NavLink>
              </NavItem>
              <NavItem
                className={classnames({
                  active: filterLolRequests && filterLolRequests.column === "status" && filterLolRequests.value === "PENDING"
                })}
              >
                <NavLink to="#" onClick={e => this.addFilter("status", "PENDING")}>
                  <i className="simple-icon-refresh" />
                  <IntlMessages id="request.pending-tasks" />
                  <span className="float-right">{loading && pendingCount}</span>
                </NavLink>
              </NavItem>
              <NavItem
                className={classnames({
                  active: filterLolRequests && filterLolRequests.column === "status" && filterLolRequests.value === "CLOSED"
                })}
              >
                <NavLink to="#" onClick={e => this.addFilter("status", "CLOSED")}>
                  <i className="simple-icon-check" />
                  <IntlMessages id="request.completed-tasks" />
                  <span className="float-right">{loading && closedCount}</span>
                </NavLink>
              </NavItem>
              <NavItem
                className={classnames({
                  active: filterLolRequests && filterLolRequests.column === "status" && filterLolRequests.value === "CANCELED"
                })}
              >
                <NavLink to="#" onClick={e => this.addFilter("status", "CANCELED")}>
                  <i className="simple-icon-close" />
                  <IntlMessages id="request.status_canceled" />
                  <span className="float-right">{loading && canceledCount}</span>
                </NavLink>
              </NavItem>
            </ul>
          </div>
        </PerfectScrollbar>
      </ApplicationMenu>
    );
  }
}

const mapStateToProps = ({ requestApp }) => {
  return {
    requestApp
  };
};
export default connect(
  mapStateToProps,
  {
    getLolRequestsSearch,
    getLolRequestsWithOrder,
    getLolRequestsWithFilter
  }
)(AlacarteApplicationMenu);
